import React from "react";
import { Dropdown, Icon } from "semantic-ui-react";
import { connect } from "react-redux";
import "./styles.css";
import { selectLocations } from "../../modules/analytics/AnalyticsActions";
import { addLocation } from "../../modules/filterLocation/filterLocationActions";

const stateOptions = [
  { key: "AL", value: "AL", text: "Demo 4" },
  { key: "BL", value: "BL", text: "Demo 2" },
  { key: "CL", value: "CL", text: "Demo 3" },
  { key: "DL", value: "DL", text: "Demo 4" }
];

class MultiSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      tempLocations: [],
      locationsList: this.props.locations
    };

    this.onSelectItem = this.onSelectItem.bind(this);
    this.isAvailable = this.isAvailable.bind(this);
    this.onFilterLocations = this.onFilterLocations.bind(this);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      locationsList: nextProps.locations
    });
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({
        isOpen: false
      });
    }
  }

  isAvailable(id) {
    let { selectedLocations } = this.props;
    let temp = selectedLocations || [];
    let item = temp.find(location => {
      return location === id;
    });

    if (item) {
      return true;
    }
    return false;
  }
  onSelectedLocationsChange(selectedItems) {
    let { tempLocations } = this.state;
    if (
      JSON.stringify(tempLocations.sort()) ===
      JSON.stringify(selectedItems.sort())
    ) {
      this.setState({ isOpen: false });
      return;
    }

    this.setState({ isOpen: false, tempLocations: selectedItems });
    this.props.selectLocations(selectedItems);
    // .then(res => {
    // this.setState({
    //   tempLocations: selectedItems
    // });
    // });
  }

  onSelectItem(id) {
    let { locations } = this.props;
    if (locations.length === 1) {
      return;
    }
    this.props.addLocation(id);
  }

  onFilterLocations(e) {
    let text = e.target.value;
    let tempLocations = this.props.locations.filter(location => {
      return location.name.toLowerCase().indexOf(text.toLowerCase()) > -1;
    });
    this.setState({
      locationsList: tempLocations
    });
  }
  render() {
    let { locations, selectedLocations } = this.props;
    // console.log("Locations",{locations},selectLocations,selectLocations[0])
    let { locationsList } = this.state;
    var renderText = () => {
      if (locations.length === 1) {
        return locations[0].id;
      }
      switch (selectedLocations.length) {
        case 0:
          return "All";
        case 1:
          return selectedLocations[0];
        default:
          return selectedLocations.length + " selected";
      }
    };
    // console.clear();
    // console.log("locations list", locationsList);
    return (
      <div className="main-container" ref={this.setWrapperRef}>
        <div
          className={renderText().length > 12 ? 'text-container text-container-expanded' : 'text-container' }
          onClick={() => this.setState({ isOpen: !this.state.isOpen })}
        >
          <h5 className="location-container_text">Location: {renderText()}</h5>
          <div className="location-icon">
            <img src="/Location_icon.png" />
          </div>
        </div>

        {this.state.isOpen ? (
          <div className="dropdown-menu_item">
            <div
              style={{
                maxHeight: "25em",
                overflow: "scroll",
                overflowX: "hidden"
              }}
            >
              {locations.length > 1 ? (
                <div className="location-search_container">
                  <Icon name="search" style={{ color: "dimgray" }} />
                  <input
                    type="text"
                    className="location-input_search"
                    onChange={this.onFilterLocations}
                  />
                </div>
              ) : null}
              {locationsList.map((location, index) => {
                return (
                  <div
                    key={index}
                    className="dropdown-element"
                    onClick={() => {
                      this.onSelectItem(location.id);
                    }}
                  >
                    {location.name}
                    {this.isAvailable(location.id) ||
                    ((location.id === "all" &&
                      selectedLocations.length === 0) ||
                      locations.length === 1) ? (
                      //<h5>check </h5>
                      <Icon name="check" style={{ color: "#409b23" }} />
                    ) : null}
                  </div>
                );
              })}
            </div>
            <button
              className="confirm-button applyBtn btn btn-sm btn-success"
              onClick={() => {
                this.onSelectedLocationsChange(selectedLocations);
              }}
            >
              Confirm
            </button>
          </div>
        ) : null}
      </div>
    );
  }
}

let mapStateToProps = state => {
  // console.log("state : ",state)
  return {
    locations: state.auth.filters ? state.auth.filters.locations : [],
    selectedLocations: state.selectedLocations
  };
};
export default connect(
  mapStateToProps,
  {
    selectLocations,
    addLocation
  }
)(MultiSelect);



// WEBPACK FOOTER //
// ./src/components/MultiSelect/index.js